import React from 'react';
import cx from 'classnames';
import {PriorityIcon} from '@priority-software/priority-style-react';
import {SearchableList} from '../../../../../../../../components/SearchableList';
import {useScrollWrapDimensions} from '../../../../../../../../hooks/customScroll/useScrollWrapDimensions';

type ListItemData = {
    label: string;
    value: string | number | boolean;
    icon?: PriorityIcon;
    data?: unknown;
    description?: string;
};

export const ScrollableList = (props: {
    data: Array<ListItemData>;
    onItemClick: (option: ListItemData) => void;
    showSearch?: boolean;
    selectedValue?: string;
    componentClasses?: string;
    noOptionsText?: string;
}) => {
    const {data, selectedValue, onItemClick, showSearch, componentClasses, noOptionsText} = props;
    const {maxHeight, setWrapRef} = useScrollWrapDimensions();

    return (
        <div className={cx('pui-scrollable-wrap', componentClasses)} ref={setWrapRef}>
            <SearchableList
                autoHeightMax={maxHeight}
                onItemClick={onItemClick}
                data={data}
                showSearch={showSearch}
                selectedValue={selectedValue}
                componentClasses={componentClasses}
                noOptionsText={noOptionsText}
            />
        </div>
    );
};
